module.exports = __webpack_public_path__ + "PairanoiaLogo.png";